import { useState } from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

function InternalNotesModal({ quote, onSave, onCancel }) {
  const [notes, setNotes] = useState(quote.internalNotes || '');
  const maxLength = 1000;

  const handleSave = () => {
    if (notes.length > maxLength) {
      alert(`Notes cannot exceed ${maxLength} characters`);
      return;
    }
    onSave(notes);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Edit Internal Notes</h3>
          <p className="text-sm text-gray-600 mt-1">
            Quote for {quote.contact?.name} ({quote.contact?.email})
          </p>
        </div>

        {/* Body */}
        <div className="px-6 py-4">
          <div className="mb-2 flex justify-between items-center">
            <label className="block text-sm font-medium text-gray-700">
              Internal Notes
            </label>
            <span className={`text-xs ${notes.length > maxLength ? 'text-red-600' : 'text-gray-500'}`}>
              {notes.length} / {maxLength}
            </span>
          </div>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows="8"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            placeholder="Add internal notes about this quote (visible only to admins)..."
          />
          <p className="mt-2 text-xs text-gray-500">
            These notes are for internal use only and will not be visible to the customer.
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            <XCircleIcon className="h-5 w-5" />
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={notes.length > maxLength}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <CheckCircleIcon className="h-5 w-5" />
            Save Notes
          </button>
        </div>
      </div>
    </div>
  );
}

export default InternalNotesModal;
